import "./oceanBay.scss";
import "../perfume.scss";
import SEO from "components/seo/SEO";

// Images
// import MainImage from "assets/img/perfume/ocean_bay_main.webp";
import ConcentrationImage from "assets/img/perfume/ocean_bay_concentration.webp";
import MainVideoWEBM from "assets/video/perfume/ocean_bay/ocean_bay_webBG.webm";
// import MainVideoMobWEBM from "assets/video/perfume/ocean_bay/ocean_bay_mob.webm";
import MainVideoMobWEBM from "assets/video/perfume/ocean_bay/ocean_bay_mobBG.webm";
import Ingredients1 from "assets/img/perfume/ingredients/white-and-pale-yellow-freesia.webp";
import Ingredients2 from "assets/img/perfume/ingredients/textured-driftwood-with.webp";
import Ingredients3 from "assets/img/perfume/ingredients/dark-oily-vanilla-beans-emer.webp";
import Ingredients4 from "assets/img/perfume/ingredients/dark-blue-blueberries-and-light.webp";
import Ingredients5 from "assets/img/perfume/ingredients/mandarin-segments-crashing-in.webp";
import Ingredients6 from "assets/img/perfume/ingredients/gnarled-driftwood-standing-in-fine-sand-clusters-o.webp";
import Ingredients7 from "assets/img/perfume/ingredients/single-pink-ros.webp";
import Ingredients8 from "assets/img/perfume/ingredients/patchouli-plant-on-pure-white-vert.webp";
import Details from "../components/details/Details";
import productStore from "store/productStore";
import { useEffect, useState } from "react";
import ProductReview from "../components/productReview/ProductReview";
// import ProductSlider from "../components/productSlider/ProductSlider";
import Ingredients from "../components/ingredients/Ingredients";
// import FirstContent from "../components/firstContent/FirstContent";
import Concentration from "../components/concentration/Concentration";
import { ENV, OCEAN_BAY_ID } from "constant";
// import VideoWithEndImage from "../components/videoWithEndImage/VideoWithEndImage";
// import HomeCarousel from "../../home/homeCarousel/HomeCarousel";
import ProductSliderNew from "../components/productSlider/ProductSliderNew";
import VideoWithEndImageNew from "../components/videoWithEndImage/VideoWithEndImageNew";

import sliderImage1 from "assets/img/perfume/slider/posttrioswipe1ob.webp";
import sliderImage2 from "assets/img/perfume/slider/posttrioswipe2ob.webp";
import imageLoadStore from "store/imageLoadStore";
import MyLoader from "components/myLoader/MyLoader";

const OceanBay = () => {
  const ImageLoadStore = imageLoadStore();
  const ProductStore = productStore();
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const AccordionDetails = [
    {
      label: "DESCRIPTION",
      content: (
        <div>
          A sophisticated fruity-floral fragrance with a smooth
          vanilla-patchouli finish. Ocean Bay starts with fresh bergamot,
          mandarin, blackcurrant nectar, and freesia for a bright, uplifting
          feel. The floral heart of rose, neroli, osmanthus, and artemisia adds
          elegance and softness. It settles into a warm base of patchouli,
          vanilla, ambroxan, and woody notes for a refined and long-lasting
          trail.
          <br />
          <br />
          Elegant, fresh, and modern — perfect for everyday luxury.
        </div>
      ),
    },
    {
      label: "FRAGRANCE NOTES",
      content: (
        <p>
          <strong>Top Notes: </strong> Blackcurrant Nectar, Bergamot, Mandarin,
          Freesia
          <br />
          <strong>Middle Notes: </strong>Rose de Mai, Neroli, Osmanthus,
          Artemisia
          <br />
          <strong>Base Notes: </strong>Patchouli, Vanilla, Ambroxan, Woody Notes
        </p>
      ),
    },
    {
      label: "FEELINGS",
      content: <p>Elegant • Fresh • Feminine • Graceful • Luxurious</p>,
    },
    {
      label: "OCCASIONS",
      content: (
        <ol>
          <li>Daytime Wear</li>
          <li>Brunch & Events</li>
          <li>Office</li>
          <li>Evening Elegance</li>
        </ol>
      ),
    },
    {
      label: "BEHIND THE PERFUME",
      content: (
        <p>
          Ocean Bay balances fruity freshness with floral richness and a creamy
          woody base. The vanilla-patchouli combination gives it warmth while
          keeping the scent airy and sophisticated.
        </p>
      ),
    },
    {
      label: "SHIPPING & RETURN",
      content: (
        <p>
          We carefully pack and dispatch all orders to ensure safe delivery.
          Orders are processed within standard business timelines.
          <br />
          <strong>Please note:</strong> Due to hygiene and product safety
          reasons, we do not accept returns or exchanges once the product has
          been delivered.
        </p>
      ),
    },
    {
      label: "LEGAL INFORMATION",
      content: (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div>
            <p style={{ fontWeight: 700 }}>Marketed by KRISTIVE</p>
            <p>
              105, Shubham Residency 1, Navagam Surat 394210, Gujarat, India
            </p>
          </div>
          <div>
            <p>
              <strong>Customer Care:</strong>
            </p>
            <p>
              <strong>Email</strong> - support@kristive.com
            </p>
            <p>
              <strong>Call</strong> - +91 81601 92573
            </p>
            <p>
              <strong>Website</strong> - www.kristive.com
            </p>
          </div>
          <div>
            <p>
              <strong>Manufactured by</strong>
            </p>
            <p>
              MINATI ESSENTIALS 8, Laxmi Narayan Industries, Udhna Surat,
              Gujarat - 394210
            </p>
            <strong>Lic. No.: </strong>GC/2055
          </div>
          <div>
            <p>
              <strong>Country of Origin:</strong> India
            </p>
            <p>
              <strong>Net Contents:</strong> 50ML / 1.7 fl. oz
            </p>
          </div>
          <div>
            <p>
              <strong>Ingredients:</strong>
            </p>
            <p>
              Linalool, Geraniol, Limonene, Eugenol, Denatured Ethyl Alcohol,
              Fragrance Oil.
            </p>
          </div>

          <div>
            <p>For External Use Only.</p>
            <p>Store in a Cool & Dry Place.</p>
          </div>

          <div>
            <p>
              <strong>Usage:</strong>
            </p>
            <p>
              To avoid staining, spray perfume from a safe distance of 15-20 cm.
            </p>
          </div>
          <div>
            <p>
              <strong>Warning:</strong>
            </p>
            <p>Keep away from children and pets.</p>
            <p>Avoid contact with eyes, mouth, and broken skin.</p>
            <p>Flammable - Keep away from heat, sparks, and open flame.</p>
          </div>

          <div>
            <p>
              <strong>Generic Name:</strong> Perfume
            </p>
            <p>Best Before: 36 months from manufacturing date.</p>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0 });
    fetchSpecificProductRating();
    if (ImageLoadStore.imageLoading) {
      setTimeout(() => {
        document.body.style.overflowY = "hidden";
      }, 50);
    }
  }, []);

  const fetchSpecificProductRating = async () => {
    setIsLoading(true);
    const product = await ProductStore.fetchOneProduct({
      _id: OCEAN_BAY_ID,
    });
    setProduct(product);
    setIsLoading(false);
  };

  return (
    <>
      <SEO
        title="Ocean Bay Perfume | Fruity Floral Vanilla Patchouli Scent"
        description="Ocean Bay is a sophisticated fruity-floral perfume with rose, vanilla, and patchouli. Fresh, elegant, and long-lasting for day-to-night wear."
      />
      {ImageLoadStore.imageLoading && (
        <div className="loading">
          <MyLoader height="100vh" />
        </div>
      )}
      <div className="perfume-details ocean-bay">
        <VideoWithEndImageNew
          websiteVideoWEBM={MainVideoWEBM}
          mobileVideoWEBM={MainVideoMobWEBM}
          product={product}
          slogan="The Scent of Coastal Freedom."
        />
        {/* {product?.productImages.length > 0 && (
          <ProductSliderNew images={product?.productImages || []} />
          )} */}
        <ProductSliderNew images={[sliderImage1, sliderImage2]} />
        <div className="content">
          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              width: "100%",
              height: "80vh",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                color: "#13435c",
              }}
            >
              <h1 style={{ fontSize: "2.5rem", lineHeight: 0.8 }}>Ocean Bay</h1>
              <p style={{ fontSize: "0.5rem" }}>Feel the Depth of Freshness</p>
            </div>
            <img
              src={TestImage}
              alt="TestImage"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
                zIndex: 10,
              }}
            />
          </div> */}

          {/* <VideoWithEndImage image={MainVideoLastImage} video={MainVideo} /> */}
          {/* <FirstContent
            title={"OCEAN BAY"}
            shortDescription={"Feel the Depth of Freshness"}
            image={MainImage}
            id={OCEAN_BAY_ID}
            productName={product?.productName || ""}
            regularPrice={product?.regularPrice || ""}
            salePrice={product?.salePrice || null}
          /> */}

          {/* {product?.productImages.length > 0 && (
            <ProductSlider images={product?.productImages || []} />
          )} */}

          {/* {product?.productImages.length > 0 && (
            <ProductSliderNew images={product?.productImages || []} />
          )} */}

          <Ingredients
            Ingredients1={{
              img: Ingredients1,
              name: "Freesia",
              desc: "Fresh, light, sweet floral aroma",
            }}
            Ingredients2={{
              img: Ingredients2,
              name: "Bergamot",
              desc: "Bright citrusy and slightly floral freshness",
            }}
            Ingredients3={{
              img: Ingredients3,
              name: "Vanilla",
              desc: "Warm, sweet, creamy comforting scent",
            }}
            Ingredients4={{
              img: Ingredients4,
              name: "Blackcurrant Nectar",
              desc: "Juicy, sweet, fruity berry richness",
            }}
            Ingredients5={{
              img: Ingredients5,
              name: "Mandarin",
              desc: "Sweet, vibrant citrus with juicy freshness",
            }}
            Ingredients6={{
              img: Ingredients6,
              name: "Neroli",
              desc: "Soft floral with fresh citrus elegance",
            }}
            Ingredients7={{
              img: Ingredients7,
              name: "Rose De Mai",
              desc: "Luxurious rich rose with soft sweetness",
            }}
            Ingredients8={{
              img: Ingredients8,
              name: "Patchouli",
              desc: "Deep earthy woody with warm sensuality",
            }}
          />

          <Concentration
            image={ConcentrationImage}
            percentage={25}
            shortDescription={
              "Elegant Blend of Fruity Freshness and Deep Floral Richness"
            }
          />

          <Details items={AccordionDetails} />

          <ProductReview
            isLoading={isLoading}
            averageRating={product?.averageRating || 0}
            totalReview={product?.ratingCount || 0}
            ratings={product?.ratings || []}
            particularRatings={{
              fiveStar: product?.fiveStar,
              fourStar: product?.fourStar,
              threeStar: product?.threeStar,
              twoStar: product?.twoStar,
              oneStar: product?.oneStar,
            }}
            appBarColor={"#13435c"}
          />
        </div>
      </div>
    </>
  );
};

export default OceanBay;
